import React, {useContext} from 'react';
import "./meet.scss";
import { AppContext } from '../../services/translationContext';
import { InsightsSection } from '../../components/sections/insights/insights';
import { ClientStoriesSection } from '../../components/sections/client-stories/client-stories';
import { PageHero } from '../../components/page-hero/page-hero';
import { EventsSection } from '../../components/sections/events/events';
import parse from 'html-react-parser';

export const Meet = () => {
  const { services: {TranslationsService} } = useContext(AppContext);
  document.title = `${TranslationsService.labels(`menu.insights.label`)} | ${TranslationsService.getMainInfoCompany('name')}`;


  return (
    <div style={{background: '#f6f6f6'}}>{parse(TranslationsService.labels(`meet_page.longText`))}</div>
  );
};